import { render, staticRenderFns } from "./HolidayDoodle.vue?vue&type=template&id=d8a22d50&scoped=true&"
import script from "./HolidayDoodle.vue?vue&type=script&lang=js&"
export * from "./HolidayDoodle.vue?vue&type=script&lang=js&"
import style0 from "./HolidayDoodle.vue?vue&type=style&index=0&id=d8a22d50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a22d50",
  null
  
)

export default component.exports